import type { User } from '@repo/domain';
import { clearQueryCache, queryClient, userOptions } from '@repo/domain-service';
import { changeLanguage } from '@repo/locale';

import { useAuthStore } from '@features/auth/stores/useAuthStore';
import { useAuthFormStore } from '@features/auth/stores/useAuthFormStore';
import { useHeldRolesStore } from '@features/auth/stores/useHeldRolesStore';

import { useLanguageStore } from '@shared/stores/useLanguageStore';
import { resetUserStores } from '@shared/utils/resetUserStores';

export function logout(): void {
  useAuthStore.getState().logout();
  useHeldRolesStore.getState().reset();
  resetUserStores();
  clearQueryCache();
}

export function finalizeLogin(user: User): void {
  const accessToken = useAuthStore.getState().accessToken;
  if (!accessToken) return;

  useAuthStore.getState().login(user, accessToken);
  useAuthFormStore.getState().reset();
  queryClient.setQueryData(userOptions.me().queryKey, user);
  queryClient.invalidateQueries({ queryKey: ['ownedParkings'] });

  if (useLanguageStore.getState().language !== user.language) {
    void changeLanguage(user.language);
    useLanguageStore.getState().setLanguage(user.language);
  }
}
